import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import PrototypeRoomListModuleTypes from '@/store/modules/middleGround/member/prototypeRoomList/interface';

const prototypeRoomListModule: Module<PrototypeRoomListModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pagePrototypeRoomList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/pagePrototypeRoomList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listHouseNature(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listHouseNature", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listDecorateType(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listDecorateType", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listDecorateStyle(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listDecorateStyle", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        pageProjectList(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/pageProjectList", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        deletePrototypeRoom(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/deletePrototypeRoom", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listPrototypeRoomImage(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listPrototypeRoomImage", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        deletePrototypeRoomImage(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/deletePrototypeRoomImage", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveOrUpdatePrototypeRoom(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/saveOrUpdatePrototypeRoom", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
    },
};

export default prototypeRoomListModule;